import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Constant } from '../constant';
import { saveAs } from 'file-saver';
import QRCode from 'qrcode';
@Component({
  selector: 'app-attendance-share', standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './attendance-share.component.html',
  styleUrls: ['./attendance-common.css', './attendance-share.component.css'],
})
export class AttendanceShareComponent {
  @Input({required:true}) eventId = 0;
  shareMessage = ''; qrDataUrl = ''; qrError = '';
  constructor(private router: Router) {}
  ngOnChanges(): void { this.generateQr(); }

  get participantUrl(): string {
    return `${location.origin}/attendance/${encodeURIComponent(localStorage.getItem(Constant.lsCompanyCode) || '')}/${this.eventId}`;
  }

  async copyUrl(): Promise<void> {
    try { await navigator.clipboard.writeText(this.participantUrl); this.shareMessage = 'URLをコピーしました。'; }
    catch { this.shareMessage = 'URLを選択してコピーしてください。'; }
  }

  async copyQr(): Promise<void> {
    if (!this.qrDataUrl) return;
    try {
      const blob = await (await fetch(this.qrDataUrl)).blob();
      if (typeof ClipboardItem === 'undefined' || !navigator.clipboard?.write) throw new Error('unsupported');
      await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
      this.shareMessage = 'QR画像をコピーしました。メール本文などに貼り付けられます。';
    } catch {
      this.shareMessage = 'このブラウザでは画像をコピーできません。PNGを保存して添付してください。';
    }
  }

  async saveQr(): Promise<void> {
    if (!this.qrDataUrl) return;
    try {
      const blob = await (await fetch(this.qrDataUrl)).blob();
      saveAs(blob, `attendance-${this.eventId}-qr.png`);
      this.shareMessage = 'QR画像をPNGで保存しました。';
    } catch {
      this.shareMessage = 'QR画像を保存できませんでした。URLをコピーして共有してください。';
    }
  }

  openPoster(): void {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/myevent-detail', this.eventId, 'attendance', 'qr-poster']));
    window.open(url, '_blank', 'noopener');
  }

  private async generateQr(): Promise<void> {
    this.qrError = '';
    try {
      this.qrDataUrl = await QRCode.toDataURL(this.participantUrl, {
        type: 'image/png', width: 512, margin: 4, errorCorrectionLevel: 'M',
        color: { dark: '#000000', light: '#ffffff' },
      });
    } catch {
      this.qrDataUrl = '';
      this.qrError = 'QRコードを生成できませんでした。URLをコピーして共有してください。';
    }
  }

}
